import { render, staticRenderFns } from "./brokerInsuredEdit.vue?vue&type=template&id=19016593&scoped=true"
import script from "./brokerInsuredEdit.vue?vue&type=script&lang=js"
export * from "./brokerInsuredEdit.vue?vue&type=script&lang=js"
import style0 from "./brokerInsuredEdit.vue?vue&type=style&index=0&id=19016593&prod&scoped=true&lang=css"
import style1 from "./brokerInsuredEdit.vue?vue&type=style&index=1&id=19016593&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19016593",
  null
  
)

export default component.exports